// Button primitive — the design's four button voices. Visuals live entirely
// in styles.css off theme tokens (§16.3); this component only composes class
// names from primitive props (react-perf: no object/array props).

import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ButtonVariant = 'primary' | 'outline' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** 99px pill radius (join/leave CTAs) instead of the default 10px. */
  pill?: boolean;
  /** Stretch to the container width. */
  block?: boolean;
  children?: ReactNode;
}

export function Button({
  variant = 'outline',
  size = 'md',
  pill = false,
  block = false,
  className,
  ...rest
}: Props) {
  const cls = [
    'bz-btn',
    `bz-btn-${variant}`,
    `bz-btn-${size}`,
    pill ? 'bz-btn-pill' : '',
    block ? 'bz-btn-block' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  return <button type="button" className={cls} {...rest} />;
}
